/**
 * @Create idler.zhu(zqc.sunny@aliyun.com)
 * @CreateDate  2017/12/25
 */
import './index.css';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import Select, { Option } from 'rc-select';

class SelectMenu extends Component{
  static propTypes = {
    notFoundContent: 'Not Found',
    placeholder: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    list: PropTypes.array,
    displayKey: PropTypes.string,
    valueKey: PropTypes.string,
    value: PropTypes.any,
    text: PropTypes.string
  };
  static defaultProps = {
    placeholder: '',
    text: '',
    value: '',
    list: []
  };
  prefix = 'store-select';
  state = {
    value: this.props.value
  };
  constructor (props) {
    super(props);
    this.mapValuesFromList(this.props);
  }
  mapValuesFromList (prpos) {
    const { list, valueKey } = prpos;
    this.values = list.map(item => valueKey ? item[valueKey] : item);
  }
  handleSelect = (value) => {
    const { onChange, displayKey, list } = this.props;
    const item = list[this.values.indexOf(value)];
    const text = displayKey ? item[displayKey] : item;
    this.setState({
      value,
      text
    });
    onChange(text, value, item);
  };
  componentWillReceiveProps (nextProps){
    if (nextProps.list !== this.props.list) {
      this.mapValuesFromList(nextProps);
    }
  }
  render () {
    const { placeholder, list, displayKey, value, notFoundContent } = this.props;
    return <Select
      notFoundContent={notFoundContent}
      value={value ? value : []}
      placeholder={placeholder}
      showArrow={false}
      prefixCls={this.prefix}
      optionFilterProp="title"
      optionLabelProp="children"
      onChange={this.handleSelect}
      backfill>
      {list.map((item, index) => {
        const text = displayKey ? item[displayKey] : item;
        return <Option value={this.values[index]}
                       text={text} title={text} key={index}>
          {text}
        </Option>
      })}
    </Select>
  }
}

export default SelectMenu;



// WEBPACK FOOTER //
// ./src/components/lib/select/index.js